import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const applicationStatusTabs = {
    mobile: {
        answerTab: {
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
                margin: "3.23vh 0 0.78vh 0"
            },
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            total: {
                color: Color.LightBlack,
                fontWeight: "bold",
                marginLeft: "auto",
                marginRight: "4.83vw",
                fontSize: "4.34vw"
            },
            score: {
                color: Color.DeepBlack,
                fontWeight: "bold",
                fontSize: "7.24vw"
            },
            text: {
                color: Color.DeepAsh,
                marginLeft: "3.79vw",
                fontSize: "3.86vw"
            },
            screeningStatus: {
                display: "flex",
                margin: "1.69vw 0 6.28vw 0",
                alignItems: "center",
                icon: {
                    width: "3.73vw",
                    height: "3.73vw",
                    marginLeft: "auto"
                }, 
                text: {
                    marginLeft: "3.56vw",
                    color: Color.DeepAsh,
                    fontSize: "3.86vw"
                },
                bold: {
                    fontWeight: "bold"
                }
            },
            questionWrapper: {
            },
            question: {
                display: "flex",
                flexDirection: "column",
                borderRadius: "2.41vw",
                border: "3px solid " + Color.Gainsboro,
                padding: "4.83vw 6.28vw",
                marginTop: "3.86vw",
                row: {
                    display: "flex",
                    flexDirection: "row" as "row",
                },
                text: {
                    color: Color.DeepAsh,
                    whiteSpace: "pre-line",
                    marginTop: "4.83vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    maxWidth: "60vw",
                    userSelect: "text"
                },
                knockout: {
                    color: Color.Red,
                    marginLeft: "2vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                },
                score: {
                    color: Color.DeepAsh,
                    margin: "4.83vw 0 0 auto",
                    height: "8.21vw",
                    borderLeft: "2px solid " + Color.Gainsboro,
                    paddingLeft: "5.67vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    display: "flex"
                },
                icon: {
                    width: "4.73vw",
                    height: "4.73vw",
                    alignSelf: "center"
                }
            },
            questionNumber: {
                color: Color.DeepAsh,
                fontWeight: "bold",
                fontFamily: Font.Poppins,
                fontSize: "4.34vw"
            },
            answerWrapper: {
                text: {
                    color: Color.DeepAsh,
                    marginTop: "4.83vw",
                    fontWeight: "bold",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                },
                answers: {
                    color: Color.DeepAsh,
                    whiteSpace: "pre-line",
                    margin: "4.83vw 0",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    userSelect: "text"
                },
                list: {
                    margin: 0, 
                    paddingLeft: "4.83vw"
                },
                seeMore: {
                    color: Color.Blue,
                    fontWeight: "bold",
                    marginLeft: "2vw",
                    cursor: "pointer"
                }
            }
        },
        cvTab: {
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                margin: "3.23vh 0 2.67vh"
            },
            text: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            link: {
                marginLeft: "10.62vw",
                textDecoration: "none",
                color: Color.Blue,
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                fontSize: "3.86vw"
            },
            icon: {
                marginLeft: "0.92vw",
                stroke: Color.Blue,
                width: "2.93vw",
                height: "2.93vw"
            },
            button: {
                marginLeft: "auto",
                width: "32.36vw",
                height: "8.45vw",                
                borderRadius: "2.41vw",
                fontSize: "4.34vw",
                border: "2px solid " + Color.Green,
                color: Color.LightBlack,
                backgroundColor: Color.White
            },
            holder: {
                position: "relative" as "relative",
                border: "1px solid " + Color.MiddleAsh,
                borderRadius: "2.41vw",
                height: "122.46vw",
                marginBottom: "7.60vw",
                cursor: "pointer",
                overflow: "hidden"
            },
            layer: {
                position: "absolute" as "absolute",
                bottom: "0",
                left: "0",
                top: "0",
                right: "0",
                background: "transparent linear-gradient(180deg, #00000000 0%, #000000 100%) 0% 0% no-repeat padding-box"
            },
            name: {
                marginBottom: "7px",
                position: "absolute" as "absolute",
                left: "1.04vw",
                bottom: "1.04vw",
                fontSize: "4.34vw",
                color: Color.White
            },             
            documentViewer: {
                height: "100%"
            }
        },
        coverLetterTab: {
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
                margin: "3.23vh 0 2.90vh 0"
            },
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            coverLetter: {
                display: "flex",
                flexDirection: "column",
                borderRadius: "2.41vw",
                border: "3px solid " + Color.Gainsboro,
                padding: "4.83vw 6.28vw",
                marginTop: "3.86vw",
                text: {
                    color: Color.DeepAsh,
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                }
            }
        },
        informationTab: {
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw",
                margin: "5.02vh 0 0 0"
            },
            personalSummary: {
                marginTop: "9.90vw",
                title: {
                    color: Color.LightBlack,
                    fontWeight: "bold",
                    fontSize: "4.83vw"
                },
                text: {
                    color: Color.MiddleBlack,
                    fontWeight: "300",
                    fontSize: "3.86vw",
                    marginTop: "7.24vw",
                    userSelect: "text"
                }
            },
            seeMore: {
                color: Color.Blue,
                fontWeight: "bold",
                marginLeft: "2vw",
                cursor: "pointer"
            },
            details: {
                marginTop: "7.24vw",
                box: {
                    borderRadius: "2.41vw",
                    border: "1px solid " + Color.SharpAsh,
                    marginBottom: "2.41vw",
                    padding: "2.65vw 4.83vw"
                },
                title: {
                    color: Color.DeepAsh,
                    fontWeight: "bold",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    preferredSectors: {
                        marginBottom: "2vw"
                    }
                },
                text: {
                    color: Color.DeepAsh,
                    fontWeight: "300",
                    fontFamily: Font.Poppins,
                    fontSize: "3.86vw",
                    userSelect: "text"
                },
                qualifications: {
                    color: Color.DeepAsh,
                    fontWeight: "300",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    margin: "5.79vw 0 2.41vw 2.41vw"
                },
                sector: {
                    width: "fit-content",
                    height: "3.91vh",
                    paddingLeft: "4.83vw",
                    paddingRight: "4.83vw",
                    marginRight: "1.21vw",
                    marginBottom: "0.56vh",
                    textAlign: "center",
                    lineHeight: "3.91vh",
                    borderRadius: "6.04vw",
                    backgroundColor: Color.Blue,
                    color: Color.LightBlue,
                    fontSize: "3.62vw",
                    overflow: "hidden",
                    cursor: "pointer",
                    display: "inline-block",
                    flex: "0 0 auto",
                    WebkitTapHighlightColor: "transparent",
                    userSelect: "none"
                }
            },
            noApplicants: {
                wrapper: {
                    borderRadius: "2.77vw",
                    border: "1px solid " + Color.HarvestGold,
                    backgroundColor: Color.LightGold,
                    display: "flex",
                    alignItems: "center" as "center",
                    justifyContent: "center" as "center",
                    padding: "2.41vh",
                    color: Color.HarvestGold,
                    fontSize: "4.5vw",
                    fontFamily: Font.Poppins,
                    margin: "21.73vw 3vw 0",
                    textAlign: "center"
                },
                icon: {
                    marginRight: "1.43vw",
                    width: "8.33vw",
                    height: "8.33vw",
                    marginLeft: "1vw"
                }
            }
        },
        notesTab: {
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
                marginTop: "3.23vh"
            },
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            noteWrapper: {
                padding: "4.83vw 6.28vw",
                marginTop: "4.66vw",
                borderRadius: "2.41vw",
                border: "3px solid " + Color.Gainsboro,
                text: {
                    color: Color.DeepAsh,
                    fontWeight: "bold",
                    fontSize: "4.34vw",
                    fontFamily: Font.Poppins
                },
                input: {
                    border: "none",
                    width: "90%",
                    minHeight: "44.44vw",                
                    borderRadius: "2.41vw",
                    marginTop: "3.86vw",
                    padding: "3.38vw",
                    backgroundColor: Color.LightAsh,
                    resize: "none"
                },
                buttons: {
                    marginTop: "3.86vw",
                    display: "flex"
                },
                addNoteButton: {
                    width: "100%",
                    height: "8.45vw",                
                    borderRadius: "1.69vw",
                    fontSize: "3.38vw",
                    fontWeight: "bold",
                    color: Color.White,
                    backgroundColor: Color.Green,
                    boxShadow: "5px 5px 50px #00000027",
                    opacity: "1"
                },
                discardButton: {
                    width: "29.46vw",
                    height: "8.45vw",                
                    borderRadius: "1.93vw",
                    marginLeft: "2.41vw",
                    fontSize: "3.38vw",
                    fontWeight: "bold",
                    color: Color.DeepBlack,
                    border: "2px solid " + Color.DeepBlack,
                    backgroundColor: Color.White,
                    opacity: "1"
                }
            },
            previousNote: {
                padding: "5.79vw",
                marginTop: "5.79vw",
                borderRadius: "2.41vw",
                border: "3px solid " + Color.Gainsboro,
                recordInfo: {
                    display: "flex"
                },
                calendarIcon: {
                    width: "3.26vw",
                    height: "3.73vw"
                },
                details: {
                    marginLeft: "3.79vw",
                    fontSize: "3.86vw",
                    color: Color.DeepAsh
                },
                addedDate: {
                    fontWeight: "bold"
                },
                note: {
                    marginTop: "3.62vw",
                    color: Color.DeepAsh,
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                }
            }
        },
        quizTab: {
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
                margin: "4.91vh 0 2.90vh 0"
            },
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            quiz: {
                display: "flex",
                marginTop: "2vw",
                height: "auto",
                backgroundColor: Color.LightAsh,
                fontWeight: "600",
                fontSize: "3.86vw",
                color: Color.MiddleBlack,
                padding: "2vw",
                icon: {
                    width: "5vw",
                    height: "5vw",
                    alignSelf: "center",
                    marginRight: "3vw"
                },
                quizDetails: {
                    marginLeft: "auto"
                }
            },
            question: {
                display: "flex",
                flexDirection: "column",
                borderRadius: "2.41vw",
                border: "3px solid " + Color.Gainsboro,
                padding: "4.83vw 6.28vw",
                marginTop: "3.86vw",
                row: {
                    display: "flex",
                    flexDirection: "row" as "row",
                },
                text: {
                    color: Color.DeepAsh,
                    marginTop: "4.83vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                },
                score: {
                    color: Color.DeepAsh,
                    margin: "4.83vw 0 0 5.67vw",
                    height: "8.21vw",
                    borderLeft: "2px solid " + Color.Gainsboro,
                    paddingLeft: "5.67vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                }
            },
            questionNumber: {
                color: Color.DeepAsh,
                fontWeight: "bold",
                fontFamily: Font.Poppins,
                fontSize: "4.34vw"
            },
            answerWrapper: {
                text: {
                    color: Color.DeepAsh,
                    marginTop: "4.83vw",
                    fontWeight: "bold",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                },
                answers: {
                    marginTop: "4.83vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    red: {
                        color: Color.Red
                    },
                    green : {
                        color: Color.Green
                    }
                }
            }
        },
        statusTab: {
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw",
                margin: "3.23vh 0 0 0"
            },
            historyWrapper: {
                marginTop: "9.66vw",
                borderTop: "2px solid " + Color.Gainsboro,
                title: {
                    marginTop: "5.07vw",
                    color: Color.DeepAsh,
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                }
            },
            statusStep: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginRight: "2.47vw"
            },
            statusIcon: {
                height: "3.56vw",
                width: "3.56vw",
                overflow: "visible",
                zIndex: 1
            },
            verticalLine: {
                width: "1px",
                height: "100%", 
                marginTop: "-0.5vw",
                borderLeft: "0.5vw dashed" + Color.DeepBlack
            },
            appliedWrapper: {
                display: "flex",
                marginTop: "4.34vw",
                applied: {
                    flex: 1,
                    justifyContent: "space-between",
                    width: "84.29vw",
                    borderBottom: {
                        borderBottom: "2px solid " + Color.Gainsboro
                    }
                },
                statusWrapper: {
                    display: "flex"
                },
                text: {
                    color: Color.DeepAsh,
                    margin: "0 0 6.34vw 0",
                    fontSize: "3.86vw",
                    maxWidth: "34vw" 
                },
                date: {
                    color: Color.DeepAsh,
                    marginLeft: "auto",
                    fontWeight: "bold",
                    fontSize: "3.86vw",
                    maxWidth: "45vw"
                },
                name: {
                    fontSize: "3.86vw",
                    marginBottom: "1vw",
                    color: Color.DeepAsh
                },
                email: {
                    marginBottom: "2vw",
                    position: "relative"
                },
                closeButton: {
                    position: "absolute" as "absolute",
                    width: "6.28vw",
                    height: "6.28vw",
                    top: "2.42vw",
                    right: "2.83vw",
                    cursor: "pointer",
                    zIndex: "3"
                },
                emailContent: {
                    width: '95%',
                    whiteSpace: "pre-wrap",
                    padding: '1.93vw',
                    border: '1px solid #ddd',
                    borderRadius: '1.93vw',
                    wordBreak: "break-word"
                }
            },
            viewText: {
                color: Color.Blue
            }
        }
    },
    desktop: {
        answerTab: {
            rowWrapper: {
                margin: "3.70vh 0 0 0",
                alignItems: "center"
            },
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            total: {
                margin: "0 1.04vw 0 0",
                fontSize: "0.93vw"
            },
            score: {
                fontSize: "1.56vw",
                marginRight: "1.19vw"
            },
            text: {
                marginLeft: "0.81vw",
                fontSize: "0.83vw"
            },
            screeningStatus: {
                margin: "0.1vw 0 0 auto",
                alignItems: "end",
                icon: {
                    width: "0.8vw",
                    height: "0.8vw"
                }, 
                text: {
                    margin: "0 1.14vw 0 0.76vw",
                    fontSize: "0.83vw"
                }
            },
            questionWrapper: {
                margin: "1.25vw 0 14vw"
            },
            question: {
                borderRadius: "0.52vw",
                width: "26.7vw",
                padding: "1.04vw 1.35vw",
                marginTop: "0.72vw",
                text: {
                    marginTop: "1.04vw",
                    fontSize: "0.93vw",
                    maxWidth: "23vw"
                },
                knockout: {
                    fontSize: "0.93vw",
                    marginLeft: "0.3vw"
                },
                score: {
                    margin: "1.04vw 0 0 auto",
                    paddingLeft: "1.22vw",
                    fontSize: "0.93vw",
                    height: "1.77vw"
                },
                icon: {
                    width: "1.5vw",
                    height: "1.5vw"
                }
            },
            questionNumber: {
                fontSize: "0.93vw"
            },
            answerWrapper: {
                text: {
                    marginTop: "1.04vw",
                    fontSize: "0.93vw"
                },
                answers: {
                    margin: "1.04vw 0",
                    fontSize: "0.93vw"
                },
                list: {
                    paddingLeft: "1.04vw"
                },
                seeMore: {
                    marginLeft: "0.5vw"
                }
            }
        },
        cvTab: {
            rowWrapper: {
                margin: "3.70vh 0 2.31vh"
            },
            text: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            link: {
                marginLeft: "11.6vw",
                fontSize: "0.83vw"
            },
            icon: {
                marginLeft: "0.32vw",
                width: "0.7vw",
                height: "0.7vw"
            },
            button: {
                width: "6.97vw",
                height: "1.82vw",                
                borderRadius: "0.52vw",
                fontSize: "0.93vw"
            },
            holder: {
                borderRadius: "0.52vw",
                height: "35.2vw",
                marginBottom: "14vw"
            },
            name: {
                marginBottom: "7px",
                fontSize: "1.04vw"
            }
        },
        coverLetterTab: {
            rowWrapper: {
                margin: "3.70vh 0 2.22vh 0"
            },
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            coverLetter: {
                borderRadius: "0.52vw",
                width: "26.7vw",
                padding: "1.04vw 1.35vw",
                margin: "0.72vw 0 14vw 0",
                text: {
                    fontSize: "0.93vw"
                }
            }
        },
        informationTab: {
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw",
                margin: "3.70vh 0 0 0"
            },
            personalSummary: {
                marginTop: "2.08vw",
                title: {
                    fontSize: "1.04vw"
                },
                text: {
                    fontSize: "0.83vw",
                    marginTop: "1.56vw",
                    maxWidth: "29.75vw"
                }
            },
            seeMore: {
                marginLeft: "0.5vw"
            },
            details: {
                width: "30vw",
                margin: "1.56vw 0 14vw",
                box: {
                    borderRadius: "0.52vw",
                    marginBottom: "0.52vw",
                    padding: "0.57vw 1.04vw"
                },
                title: {
                    fontSize: "0.93vw",
                    preferredSectors: {
                        marginBottom: "0.5vw"
                    }
                },
                text: {
                    fontSize: "0.83vw"
                },
                qualifications: {
                    fontSize: "0.93vw",
                    margin: "1.25vw 0 0.52vw 0.52vw"
                },
                sector: {
                    marginRight: "0.52vw",
                    marginBottom: "0.52vw",
                    width: "fit-content",
                    height: "1.822vw",
                    paddingLeft: "1.04vw",
                    paddingRight: "1.04vw",
                    lineHeight: "1.822vw",
                    fontSize: "0.78vw"
                }
            },
            noApplicants: {
                wrapper: {
                    width: "98%",
                    borderRadius: "0.52vw",
                    margin: "10vh 0 0 0",
                    padding: "1.56vw 0 1.56vw 0",
                    fontSize: "0.98vw"
                },
                icon: {
                    marginRight: "1.02vw",
                    width: "1.2vw",
                    height: "1.2vw"
                }
            }
        },
        notesTab: {
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            noteSection: {
                marginBottom: "14vw"
            },
            noteWrapper: {
                padding: "1.04vw 0.83vw",
                margin: "1vw 0 1.25vw",
                borderRadius: "0.36vw",
                text: {
                    fontSize: "0.93vw"
                },
                input: {
                    minHeight: "9.58vw",                
                    borderRadius: "0.52vw",
                    marginTop: "0.83vw",
                    padding: "1.25vw"
                },
                buttons: {
                    marginTop: "0.83vw"
                },
                addNoteButton: {
                    width: "10.93vw",
                    height: "1.82vw",                
                    borderRadius: "0.36vw",
                    fontSize: "0.72vw"
                },
                discardButton: {
                    width: "6.35vw",
                    height: "1.82vw",               
                    borderRadius: "0.41vw",
                    marginLeft: "auto",
                    fontSize: "0.72vw"
                }
            },
            previousNote: {
                padding: "1.25vw",
                margin: "0 0 0.73vw",
                borderRadius: "0.52vw",
                calendarIcon: {
                    width: "0.70vw",
                    height: "0.8vw"
                },
                details: {
                    marginLeft: "0.81vw",
                    fontSize: "0.83vw"
                },
                note: {
                    maxWidth: "26.87vw",
                    marginTop: "0.41vw",
                    fontSize: "0.93vw"
                }
            }
        },
        quizTab: {
            rowWrapper: {
                margin: "3.70vh 0 2.22vh 0"
            },
            quizWrapper: {
                marginBottom: "14vw",
                cursor: "pointer"
            },
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            quiz: {
                marginTop: "1vw",
                padding: "0.5vw",
                fontSize: "1.04vw",
                quizDetailsWrapper: {
                    display: "flex",
                    width: "100%",
                    fontSize: "0.93vw",
                    alignItems: "center"
                },
                quizName: {
                    maxWidth: "10vw"
                },
                icon: {
                    width: "1vw",
                    height: "1vw",
                    marginRight: "0.5vw"
                }
            },
            question: {
                borderRadius: "0.52vw",
                width: "26.7vw",
                padding: "1.04vw 1.35vw",
                marginTop: "0.72vw",
                text: {
                    marginTop: "1.04vw",
                    fontSize: "0.93vw"
                },
                score: {
                    margin: "1.04vw 0 0 1.04vw",
                    paddingLeft: "1.22vw",
                    fontSize: "0.93vw",
                    height: "1.77vw"
                }
            },
            questionNumber: {
                fontSize: "0.93vw"
            },
            answerWrapper: {
                text: {
                    marginTop: "1.04vw",
                    fontSize: "0.93vw"
                },
                answers: {
                    marginTop: "1.04vw",
                    fontSize: "0.93vw"
                }
            }
        },
        statusTab: {
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw",
                margin: "3.70vh 0 0 0"
            },
            historyWrapper: {
                margin: "1.66vw 0 14vw 0",
                title: {
                    marginTop: "1.25vw",
                    fontSize: "0.93vw"
                }
            },
            statusStep: {
                marginRight: "0.53vw"
            },
            statusIcon: {
                height: "0.76vw",
                width: "0.76vw"
            },
            verticalLine: {
                borderLeft: "0.1vw dashed" + Color.DeepBlack,
                marginTop: "-0.2vw"
            },
            appliedWrapper: {
                marginTop: "0.93vw",
                applied: {
                    width: "28.54vw",
                    borderBottom: {
                        borderBottom: "1px solid " + Color.Gainsboro
                    }
                },
                text: {
                    margin: "0 0 0.93vw 0.53vw",
                    fontSize: "0.83vw",
                    maxWidth: "23vw" 
                },
                date: {
                    fontSize: "0.83vw",
                    maxWidth: "13vw"
                },
                name: {
                    margin: "0 0 0.5vw 0.53vw",
                    fontSize: "0.83vw"
                },
                email: {
                    marginBottom: "1vw"
                },
                emailContent: {
                    width: '97%',
                    padding: '0.41vw',
                    borderRadius: '0.41vw'
                },
                closeButton: {
                    width: "1.35vw",
                    height: "1.35vw",
                    top: "0.73vw",
                    right: "0.73vw"
                }
            }
        }
    }
}